module.exports = __webpack_public_path__ + "static/media/quiks_delivery_terms_en.64d1276f.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/quiks_delivery_terms_en.md
// module id = 63
// module chunks = 0